import { AccountType } from "@/enums/account-type";
import { snakeCaseObject } from "@/helpers/object-mapper";
import { initialState } from "@/store/modules/permissions/state";
import { FacilityPermissionsEnum } from "@/enums/facility-permissions.enum";
import { PermissionsActiveDialog } from "@/enums/permissions-active-dialog";

export default {
  setCompany({ commit }, company) {
    commit("SET_COMPANY", company);
  },

  setActiveDialog({ state, commit }, { type, mode = null }) {
    if (state.member.permissionsManagedBySso && type) {
      if (![PermissionsActiveDialog.PERMISSIONS, PermissionsActiveDialog.FACILITIES].includes(type)) {
        return;
      }
      mode = "preview";
    }
    commit("SET_MODE", mode);
    commit("SET_ACTIVE_DIALOG", type);
  },

  setAccountType({ state, commit }, type) {
    if (state.member.permissionsManagedBySso) return;
    commit("SET_ACCOUNT_TYPE", type);
    commit("SET_ALL_FACILITIES_ACCESS", type === AccountType.ADMIN);
    commit("SET_FACILITIES_IDS", []);
    commit("SET_PERMISSIONS", { ...initialState().member.permissions });
  },

  setForceLogout({ state, commit }, value) {
    if (state.member.permissionsManagedBySso) return;
    commit("SET_FORCE_LOGOUT", value);
  },

  setPermission({ state, commit }, { key, value }) {
    if (state.member.permissionsManagedBySso) return;
    const permissions = {
      ...state.member.permissions,
      [key]: value
    };

    commit("SET_PERMISSIONS", permissions);
  },

  getMemberRequestBody({ state }) {
    const {
      id,
      email,
      type,
      facilitiesIds,
      facilitiesGroupsIds,
      allFacilitiesAccess,
      permissions,
      permissionType,
      forceLogout
    } = state.member;

    const body = {
      email,
      type,
      allFacilitiesAccess
    };

    if (id && forceLogout) {
      body.forceLogout = true;
    }
    if (!allFacilitiesAccess) {
      if (permissionType === FacilityPermissionsEnum.SELECTED) {
        body.facilitiesIds = facilitiesIds;
      } else if (permissionType === FacilityPermissionsEnum.SELECT_GROUPS) {
        body.facilitiesGroupsIds = facilitiesGroupsIds;
      }
    }

    if (type === AccountType.MANAGER) {
      body.permissions = permissions;
    }

    return snakeCaseObject(body);
  }
};
